/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, August 2020
 */

import { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { FlowBlockRestart as BlockModel } from '@staffino/model';
import { useFormContext } from 'react-hook-form';
import FlowContext from '../flow-context';
import { ConditionEvaluator } from '../condition-evaluator';
import useBridge from '../use-bridge-hook';
import useTouchInterceptor from '../use-touch-interceptor';

type Props = {
  block: BlockModel;
};
function FlowRestartBlock({ block }: Props) {
  // TODO: implement idleTime

  const bridge = useBridge();
  const form = useFormContext();

  const { definition, stateManager } = useContext(FlowContext);
  const evaluator = useMemo(
    () => new ConditionEvaluator(stateManager, bridge, definition, form),
    [stateManager, bridge, definition, form],
  );
  const action = !stateManager.getActivePage() ? 'Flow.Finish' : 'Flow.Restart';
  const reset = useCallback(() => {
    evaluator.applyActions([[action]]);
  }, [action, evaluator]);

  const timerRef = useRef(undefined);

  useEffect(() => {
    timerRef.current = setTimeout(reset, (block.restartTime ?? 10) * 1000);
    return () => {
      clearTimeout(timerRef.current);
    };
  }, [reset, block.restartTime]);

  const recordInteraction = useCallback(() => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(reset, (block.restartTime ?? 10) * 1000);
  }, [reset, block.restartTime]);

  useTouchInterceptor(block.cancellable, recordInteraction);

  return null;
}

export default FlowRestartBlock;
